// 导入基本公共资源
import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
export default {
  getOperatorDailyReport(params) {
    return http.requestPost(apiPre + service.order + '/order/report/operatorDailyReport',params)
  },
  getOperatorMonthlyReport(params) {
    return http.requestPost(apiPre + service.order + '/order/report/operatorMonthlyReport',params)
  },
  getOperatorYearlyReport(params) {
    return http.requestPost(apiPre + service.order + '/order/report/operatorYearlyReport',params)
  },
  getStationDailyReport(params) {
    return http.requestPost(apiPre + service.order + '/order/report/stationDailyReport',params)
  },
  getStationMonthlyReport(params) {
    return http.requestPost(apiPre + service.order + '/order/report/stationMonthlyReport',params)
  },
  getStationYearlyReport(params) {
    return http.requestPost(apiPre + service.order + '/order/report/stationYearlyReport',params)
  },
  downloadOperator(url){
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel/operatorDailyOrder',url)
  },
  downloadOperator2(url){
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel/operatorMonthlyOrder',url)
  },
  downloadOperator3(url){
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel/operatorYearlyOrder',url)
  },
  downloadStation(url){
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel/stationDailyOrder',url)
  },
  downloadStation2(url){
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel/stationMonthlyOrder',url)
  },
  downloadStation3(url){
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel/stationYearlyOrder',url)
  },
  getOrderReport(param){
    return http.requestPost(apiPre + service.order + '/order/report/orderReportList', param)
  },
  getSettlementReport(param){
    return http.requestPost(apiPre + service.sett + '/sett/settlementOrder/report/pagerWithCondition', param)
  },
  downloadOrder(param) {
    return http.requestDownloadExcel(apiPre + service.order + '/order/report/excel', param)
  },
  downSettlement(param) {
    return http.requestDownloadExcel(apiPre + service.sett + '/sett/settlementOrder/report/excel', param)
  },
  operatorList() {
    return http.requestQuickGet(apiPre + service.member + '/member/operator/operatorSelectionList')
  },
  stationList(param) {
    return http.requestPost(apiPre + service.res + '/res/station/stationsForSelectByOperatorId',param)
  },

}



// WEBPACK FOOTER //
// ./src/module/dataCenter/api/report.js